import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { CategoryForm } from "../CategoryForm";
import { EditCategoryModalProps } from "./types";
import { useEditCategoryModal } from "./controller";

export const EditCategoryModal = React.memo(({ modalRef, onComplete }: EditCategoryModalProps) => {
  const translate = useTranslate();

  const { methods, handleSubmit, isPending } = useEditCategoryModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("category_admin.titles.edit")}
      onConfirm={handleSubmit}
      methods={methods}
      isPending={isPending}
    >
      <CategoryForm />
    </Modal>
  );
});
